module.exports = __webpack_public_path__ + "media/images/companies/tokyo_marine_nichido-04a82d9ef844d389681a69af67623a64.png";